import { DateTimeProps, GenericDateTime } from "components/Form/components/GenericDateTime/GenericDateTime";

export const Time = (props: DateTimeProps) => (
    <GenericDateTime
        {...props}
        type="time"
    />
);